import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import ContactCTA from './components/ContactCTA.jsx';
import CompanySection from './components/CompanySection.jsx';
import HomeReact from './pages/HomeReact.jsx';
import About from './pages/About.jsx';
import Contact from './pages/Contact.jsx';
import BlogComponent from './pages/BlogComponent.jsx';
import BlogPost from './pages/BlogPost.jsx';
import Privacy from './pages/Privacy.jsx';
import IndustryDetail from './pages/IndustryDetail.jsx';
import SpecializationPage from './pages/specializationPage.jsx';
import ProductsPage from './pages/ProductsPage.jsx';

function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  useEffect(() => {
    window.history.scrollRestoration = 'manual';
  }, []);
  
  return null;
}

function ConditionalContactCTA() {
  const location = useLocation();
  if (location.pathname === '/contact') {
    return null;
  }
  return <ContactCTA />;
}

function App() {
  return (
    <LanguageProvider>
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomeReact />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<BlogComponent />} />
          <Route path="/blog-post" element={<BlogPost />} />
          <Route path="/blog-post/:id" element={<BlogPost />} />
          <Route path="/products/:slug" element={<ProductsPage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/industries/:slug" element={<IndustryDetail />} />
          <Route path='/services' element={< SpecializationPage/>} />
        </Routes>
        <CompanySection />
        <ConditionalContactCTA />
        
        <Footer />
      </Router>
    </HelmetProvider>
    </LanguageProvider>
  );
}

export default App;
